namespace $ {
	export class $shm_surreal_reactive extends $mol_object {

		profile_id() { return 'local' }

		profile() {
			const profile = $shm_surreal_profile.data( this.profile_id() )
			if( !profile ) throw new Error( `Профиль SurrealDB «${ this.profile_id() }» не найден` )
			return profile
		}

		@ $mol_mem
		connection() {
			return $shm_surreal_connection.make({ profile: ()=> this.profile() })
		}

		@ $mol_mem_key
		revision( table: string, next?: number ) {
			return next ?? 0
		}

		private live_tasks = new Map< string, Promise< void > >

		@ $mol_mem_key
		live( table: string ) {
			$mol_wire_sync( this ).live_start_async( table )
			return true
		}

		async live_start_async( table: string ) {
			if( this.live_tasks.has( table ) ) return
			const subscription = await this.connection().live_async( table )
			const task = ( async ()=> {
				try {
					for await( const _change of subscription ) {
						this.revision( table, this.revision( table ) + 1 )
					}
				} finally {
					this.live_tasks.delete( table )
				}
			} )()
			this.live_tasks.set( table, task )
			task.catch( $mol_fail_log )
		}

		@ $mol_mem_key
		query( key: string ) {
			const request = JSON.parse( key ) as $shm_surreal_config_query_request
			for( const table of request.tables ?? [] ) {
				this.live( table )
				this.revision( table )
			}
			return $mol_wire_sync( this.connection() ).query_async( key ) as readonly unknown[]
		}

		invalidate( table: string ) {
			this.revision( table, this.revision( table ) + 1 )
		}
	}

	export class $shm_surreal_reactive_pool extends $mol_object {
		@ $mol_mem_key
		static store( profile_id: string, next?: $shm_surreal_reactive ) {
			return next ?? $shm_surreal_reactive.make({ profile_id: ()=> profile_id })
		}

		static reset( profile_id: string ) {
			const previous = this.store( profile_id )
			previous.connection().close_async().catch( $mol_fail_log )
			return this.store( profile_id, $shm_surreal_reactive.make({ profile_id: ()=> profile_id }) )
		}
	}
}
